import { z } from "zod";

const liveBriefingSampleSchema = z.object({
  collection_id: z.string(),
  name: z.string(),
  topics: z
    .object({
      description: z.string(),
      id: z.string(),
      live_briefing_sample_cover_page_image: z.string(),
      live_briefing_sample_inside_page_image: z.string(),
      live_briefing_sample: z.string(),
      name: z.string(),
    })
    .array(),
});

export const liveBriefingSampleResponseSchema = z.array(liveBriefingSampleSchema);
